import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({
  spacing,
  typography
}) => ({
  datePicker: {
    '& input': {
      padding: `${spacing(1.5)}px ${spacing(1.75)}px`,
      fontSize: typography.button.fontSize
    }
  }
}));